var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonaco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.27242C22.3139 1.27289 22.6743 1.40614 22.9401 1.64293C23.2059 1.87972 23.3555 2.20076 23.356 2.53563V20.2417C23.3555 20.5766 23.2059 20.8976 22.9401 21.1344C22.6743 21.3712 22.3139 21.5045 21.938 21.505H2.06201C1.6861 21.5045 1.32572 21.3712 1.05991 21.1344C0.7941 20.8976 0.644523 20.5766 0.643994 20.2417V2.53563C0.644523 2.20076 0.7941 1.87972 1.05991 1.64293C1.32572 1.40614 1.6861 1.27289 2.06201 1.27242H21.938ZM21.938 0.69873H2.06201C1.5153 0.699202 0.991126 0.892892 0.604541 1.23727C0.217956 1.58166 0.000529505 2.0486 0 2.53563V20.2417C0.000529505 20.7288 0.217956 21.1957 0.604541 21.5401C0.991126 21.8845 1.5153 22.0782 2.06201 22.0786H21.938C22.4845 22.0777 23.0084 21.8839 23.3949 21.5396C23.7813 21.1953 23.9989 20.7286 24 20.2417V2.53563C23.9995 2.0486 23.782 1.58166 23.3955 1.23727C23.0089 0.892892 22.4847 0.699202 21.938 0.69873Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 1.27246H2.06194C1.68602 1.27293 1.32565 1.40618 1.05984 1.64297C0.794027 1.87977 0.64445 2.2008 0.643921 2.53567V11.3887H23.3559V2.53567C23.3554 2.2008 23.2058 1.87977 22.94 1.64297C22.6742 1.40618 22.3138 1.27293 21.9379 1.27246Z",
    fill: "#EF0822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 20.2417C0.64445 20.5766 0.794027 20.8976 1.05984 21.1344C1.32565 21.3712 1.68602 21.5045 2.06194 21.5049H21.9379C22.3138 21.5045 22.6742 21.3712 22.94 21.1344C23.2058 20.8976 23.3554 20.5766 23.3559 20.2417V11.3887H0.643921V20.2417Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.69873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonaco);
export default __webpack_public_path__ + "static/media/Monaco.478b6a372af3b21c9a894c5bc945d1b1.svg";
export { ForwardRef as ReactComponent };